import React, { Component } from 'react'
import { connect } from 'react-redux'
import PersonForm from './person_form'
import PersonListFilter from './personListFilter'
import PersonListAdvancedFilter from './personListAdvancedFilter'
import * as actions from '../../actions'
import {List, ListItem} from 'material-ui/List';
import ActionFace from 'material-ui/svg-icons/action/face';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton'
import {lightBlack, darkBlack} from 'material-ui/styles/colors';
import Dialog from 'material-ui/Dialog';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import AppBar from 'material-ui/AppBar';
import Waypoint from 'react-waypoint';
import Checkbox from 'material-ui/Checkbox'

var FileSaver = require('file-saver');

var jsonpatch = require('fast-json-patch')
const uuidv4 = require('uuid/v4');
var params = '?';
var hasEdited = false;
var patchresponsed = true;

const styles = {
  m15: {
    margin: 15,
  },
  customContentStyle: {
    width: '100%',
    maxWidth: 'none',
  },
  block: {
    maxWidth: 250,
  },
  checkbox: {
    marginBottom: 16,
  },
  plusButton: {
    position: "fixed",
    right: 20,
    bottom: 20,
    zIndex: 1,
  }
};
var shouldSave = true;
var closeRequest = null

class Persons extends Component {

  componentWillUnmount() {
    if (this.props.errorMessage) {
      this.props.authError(null)
    }
    closeRequest = null
  }

  componentWillMount() {
    this.props.filteroptions();
    this.props.fetchMessage('/persons', '?offset=0&limit=50');
    this.props.getEnums('/dev.enum/qualification-areas', '?detailed', 'Qualification');
    this.props.getEnums('/dev.enum/qualification-types', '', 'QualificationTypes');
    this.props.getEnums('/dev.enum/membership-types', '', 'Membership');
    this.props.getEnums('/dev.enum/person-list-categories', '', 'PersonCategories');
  }

  componentDidMount() {
    var that = this
    closeRequest = function() {
      window.onbeforeunload = function() {
        that.setState({iscloserequest: true});
        that.handleFakeSubmit(false)
        if (that.state.openedform) {
          if (!that.state.isemptyonclose) {
            that.setState({iscloserequest: false});
            return 'You have unsaved changes!';
          }

        }
      }
    }
    closeRequest()
    let actualHref = window.location.href;
    if ( actualHref.substring(actualHref.length - 8).indexOf('persons') === -1 ) {
      let personId = actualHref.substring((actualHref.indexOf('persons') + 8))
      window.history.pushState({"html":document.documentElement.innerHTML,"pageTitle":document.title},"", actualHref.substring( 0, (actualHref.indexOf('persons') + 7) ));
      this.props.openPerson('/persons', '/'+personId);
      this.props.getEnums('/persons', '/'+personId+'/names', 'Names');
      this.props.getEnums('/persons', '/'+personId+'/fees', 'Fees');
      this.props.getGroupInit('/persons', '/'+personId, 'GroupInit');
      this.setState({open: true});
      this.setState({openedform: true});
    }
  }

  state = {
    mergefirst: '',
    open: false,
    checked: '',
    openedform: false,
    openedfilter: false,
    iscloserequest: false,
    isemptyonclose: false,
    filterparams: "?",
    advancedfilterparams: "?",
    advancedfilterinuse: false,
  }

  openReferedPerson = () => {
  }

  handleOpen = ( val ) => {
    this.props.openPerson('/persons', '/'+val);
    this.props.getEnums('/persons', '/'+val+'/names', 'Names');
    this.props.getEnums('/persons', '/'+val+'/fees', 'Fees');
    this.props.getGroupInit('/persons', '/'+val, 'GroupInit');
    this.setState({open: true});
    this.setState({openedform: true});
  }

  handleFilterOpen = () => {
    this.setState({open: true});
    this.setState({openedfilter: true});
  }

  handleMerge = ( val ) => {
    if (this.state.mergefirst !== '' && val !== '' && this.state.mergefirst !== val) {
      // send POST https://admin.magyarpszichodrama.hu/api/v1.0/persons.merge/első kijelölt id-ja/második kijelölt id-ja
      this.props.personMerge('/persons.merge', '/'+this.state.mergefirst+'/'+val, '')
      this.setState({mergefirst: ''});
      this.setState((oldState) => {
        return {
          checked: '',
        };
      });
      var propsForFunction = this.props
      var visibilityChecker = setInterval(function(){
        if (document.getElementById("overlay").offsetParent === null) {
          clearInterval(visibilityChecker);
          let db = {}
          db.darab = propsForFunction.message.length;
          setTimeout(function(){
            propsForFunction.fetchMessage('/persons', '?offset=0&limit='+db.darab);
          }, 150)
        }
      }, 300);

    } else if (this.state.mergefirst !== '' && this.state.mergefirst === val) {
      this.setState({mergefirst: ''});
      this.setState((oldState) => {
        return {
          checked: '',
        };
      });

    } else {
      this.setState({mergefirst: val});
      this.setState((oldState) => {
        return {
          checked: val,
        };
      });
    }
  }

  handleNewOpen = ( val ) => {
    this.props.openPerson('/persons', '/'+val);
    this.setState({open: true});
    this.setState({openedform: true});
  }

  handleFilterClose = () => {
    this.setState({open: false});
    this.setState({openedfilter: false});
  }

  handleClose = () => {
    this.handleFakeSubmit(false);
  }

  handleSubmit({id, personal, system, psychotherapist, diplomas, diplomasplus, membershipHistory, membershipHistoryNew, qualifications,qualificationsnew, comments, commentsnew, isAnonym}) {
    if (shouldSave && typeof personal.name === 'undefined' || shouldSave && personal.name === null || shouldSave && personal.name.trim() === "") {
      alert('Név megadása kötelező');
      return void(0)
    }
    let patchArrayCounter = 0;
    patchresponsed = true
    let patchArray = []
    let loadedPerson = this.props.thisperson;
    let dateString;
    if (typeof personal.birthday !== 'undefined' && personal.birthday !== null) {
      if(personal.birthday.length === 10) {
        dateString = personal.birthday;
      } else {
        if(typeof personal.birthday === 'string'){personal.birthday = new Date(personal.birthday)}
        personal.birthday.setMinutes(personal.birthday.getMinutes() - personal.birthday.getTimezoneOffset());
        dateString = personal.birthday.toISOString().slice(0,10)
      }
    }
    let phones = [];
    if (typeof personal.phone !== "undefined") {
      personal.phone.forEach(function(item){
        let pastePhoneMachine;
        if(typeof item.human !== 'undefined' && item.human !== '') {
          let tmpPhoneMachine = item.human.replace('+', '00')
          let phoneMachine = tmpPhoneMachine.replace(/[^0-9.]/g, '')
          pastePhoneMachine = phoneMachine.replace('[^0-9.]', '')
        }
        if (typeof item.human === 'undefined' || item.human.length < 1) {
          //item.human = ''
        } else {
          phones.push({"human" : item.human,"machine" : pastePhoneMachine})
        }
      })
    }
    if (typeof personal.phoneplus !== "undefined") {
      let pastePhoneMachine;
      if(typeof personal.phoneplus.human !== 'undefined' && personal.phoneplus.human !== '') {
        let tmpPhoneMachine = personal.phoneplus.human.replace('+', '00')
        let phoneMachine = tmpPhoneMachine.replace(/[^0-9.]/g, '')
        pastePhoneMachine = phoneMachine.replace('[^0-9.]', '')
      }
      if (typeof personal.phoneplus.human === 'undefined' || personal.phoneplus.human.length < 1) {
        //personal.phoneplus.human = ''
      } else {
        phones.push({"human" : personal.phoneplus.human,"machine" : pastePhoneMachine})
      }
    }
    let emails = [];
    if (typeof personal.email !== "undefined") {
      if (typeof personal.email === "string") {
        emails.push(personal.email)
      } else {
        personal.email.forEach(function(item){
          if (typeof item === 'undefined' || item.length < 1) {
            //item = ''
          } else {
            emails.push(item);
          }
        })
      }
    }
    if (typeof personal.emailplus === 'undefined' || personal.emailplus.length < 1) {
      //personal.emailplus = "";
    } else {
      emails.push(personal.emailplus)
    }

    let diploms = [];
    if (typeof diplomas !== "undefined") {
      if (typeof diplomas === "string") {
        diploms.push(diplomas)
      } else {
        diplomas.forEach(function(item){
          if(item !== null) {
            diploms.push(item);
          }
        })
      }
    }
    if (typeof diplomasplus !== "undefined") {
      diploms.push(diplomasplus)
    }

    let memberhistory = [];
    if (typeof membershipHistory !== "undefined") {
      membershipHistory.forEach(function(item){
        let itemstart;
        if (item.status !== null) {
          if (item.start.length === 10) {
            itemstart = item.start
          } else {
            if(typeof item.start === 'string'){item.start = new Date(item.start)}
            item.start.setMinutes(item.start.getMinutes() - item.start.getTimezoneOffset())
            itemstart = item.start.toISOString().slice(0,10)
          }
          if(item.status !== null) {
            memberhistory.push({"status" : item.status,"start" : itemstart});
          }
        }
      })
    }
    if (typeof membershipHistoryNew !== "undefined") {
      if (typeof membershipHistoryNew.start !== 'undefined' && membershipHistoryNew.start !== null) {
        if(typeof membershipHistoryNew.start === 'string'){membershipHistoryNew.start = new Date(membershipHistoryNew.start)}
        membershipHistoryNew.start.setMinutes(membershipHistoryNew.start.getMinutes() - membershipHistoryNew.start.getTimezoneOffset());
      }
      memberhistory.push({
        "status" : membershipHistoryNew.status,
        "start" : typeof membershipHistoryNew.start !== 'undefined' ? membershipHistoryNew.start !== null ? membershipHistoryNew.start.toISOString().slice(0,10)  : undefined : undefined
      })
    }
    let commentss = [];
    if (typeof comments !== "undefined") {
      comments.forEach(function(item, index){
        if(item.text !== null) {
          let itemtime = loadedPerson.comments[index].time
          commentss.push({"text" : item.text,"time" : itemtime});
        }
      })
    }
    if (typeof commentsnew !== "undefined") {
      commentss.push({"text" : commentsnew.text})
    }
    let qualificationss = [];
    if (typeof qualifications !== "undefined") {
      qualifications.forEach(function(item){
        if (item.area !== null) {
          let itIsTheTime = new Date(item.date)
          itIsTheTime.setMinutes(itIsTheTime.getMinutes() - itIsTheTime.getTimezoneOffset());
          qualificationss.push({"area" : item.area,"type" : item.type,"date" : typeof itIsTheTime !== 'undefined' ? itIsTheTime.toISOString().slice(0,10) : undefined });
        }
      })
    }
    if (typeof qualificationsnew !== "undefined") {
      if (typeof qualificationsnew.date !== 'undefined' && qualificationsnew.date !== null) {
        if(typeof qualificationsnew.date === 'string'){qualificationsnew.date = new Date(qualificationsnew.date)}
        qualificationsnew.date.setMinutes(qualificationsnew.date.getMinutes() - qualificationsnew.date.getTimezoneOffset());
      }
      qualificationss.push({
        "area" : qualificationsnew.area,
        "type" : qualificationsnew.type,
        "date" : typeof qualificationsnew.date !== 'undefined' ? qualificationsnew.date !== null ? qualificationsnew.date.toISOString().slice(0,10) : undefined : undefined
      })
    }
    let edited = {
      "id" : id,
      "personal" : {
        "name" : personal.name,
        "birthday" : dateString,
        "email" : emails,
        "address" : {
          "zip" : personal.address.zip,
          "country" : personal.address.country,
          "city" : personal.address.city,
          "address" : personal.address.address
        },
        "oldAddress" : personal.oldAddress,
        "postalAddress" : personal.postalAddress,
        "phone" : phones,
        "isDead" : personal.isDead === '' ? false : personal.isDead,
        "isPublicContact" : personal.isPublicContact === '' ? false : personal.isPublicContact
      },
      "system" : {
        "tbNumber" : system.tbNumber,
        "isNewsletter" : system.isNewsletter === '' ? false : system.isNewsletter,
        "indexNumber" : system.indexNumber === '' ? void(0) : system.indexNumber
      },
      "psychotherapist" : {
        "isPatientgroup" : psychotherapist.isPatientgroup === '' ? false : psychotherapist.isPatientgroup,
        "isTheory" : psychotherapist.isTheory === '' ? false : psychotherapist.isTheory,
        "isExam" : psychotherapist.isExam === '' ? false : psychotherapist.isExam,
        "isPsychotherapist" : psychotherapist.isPsychotherapist === '' ? false : psychotherapist.isPsychotherapist
      },
      "diplomas" : diploms,
      "membershipHistory" : memberhistory,
      "qualifications" : qualificationss,
      "comments" : commentss,
      "isAnonym" : isAnonym,
      "affairs" : loadedPerson.affairs
    }
    delete loadedPerson.personal.editedbirthday;
    var patch = jsonpatch.compare(loadedPerson, edited)

    patchArray.push({
      endpoint: '/persons',
      params: '/'+id,
      patchvar: patch,
      needalert: false
    })

    let propsforpatch = this.props;
    let that = this;
    let cntrObj = {};
    cntrObj.lngt = patchArray.length;
    function patcher(maybeSave) {
      if (typeof maybeSave !== 'undefined' && maybeSave === true) {
        if (patchresponsed === true) {
          if (patchArray.length === patchArrayCounter) {
            // All PATCH done
            propsforpatch.fetchMessage('/persons', params); // refresh list
            hasEdited = false;
            propsforpatch.openPerson('/persons', '/'+id); // refresh single
            alert('Sikeres módosítás')
            patcher = null
            //window.location.replace('/persons/'+id)
          } else {
            document.getElementsByTagName("body")[0].addEventListener('patchresponse'+patchArrayCounter, function (e) {
              // we have response
              patchArrayCounter++
              patchresponsed = true
              if (patcher !== null) {
                patcher(shouldSave);
              }
            }, false)
            if (typeof patchArray[patchArrayCounter] !== 'undefined' && typeof patchArray[patchArrayCounter].del !== 'undefined' && patchArray[patchArrayCounter].del === true) {
              propsforpatch.deleteParticipant(patchArray[patchArrayCounter].endpoint, patchArray[patchArrayCounter].params, patchArrayCounter)
            } else {
              propsforpatch.patchItem(patchArray[patchArrayCounter].endpoint, patchArray[patchArrayCounter].params, patchArray[patchArrayCounter].patchvar, patchArray[patchArrayCounter].needalert, patchArrayCounter)
            }
            patchresponsed = false
          }
        }
      } else {
        if (that.state.iscloserequest) {
          let isEmpty = true
          patchArray.map((option, index) => {
            if (option.patchvar.length > 0) {
              isEmpty = false
            }
          })
          if (isEmpty) {
            that.setState({isemptyonclose : true})
            return true
          } else {
            that.setState({isemptyonclose : false})
            return false
          }
        } else {
          let isEmpty = true
          patchArray.map((option, index) => {
            if (option.patchvar.length > 0) {
              isEmpty = false
            }
          })
          if (isEmpty) {
            propsforpatch.closePerson()
            propsforpatch.clearNames()
            propsforpatch.fetchMessage('/persons', params);
            that.setState({open: false});
            that.setState({openedform: false});
          } else {
            if (window.confirm('A formon el nem mentett változtatások vannak.\nHa a form bezáródik, akkor a változtatások elvesznek.\n\nBezárjuk a form-ot?')) {
              propsforpatch.closePerson()
              propsforpatch.clearNames()
              propsforpatch.fetchMessage('/persons', params);
              that.setState({open: false});
              that.setState({openedform: false});
            }
          }
        }
      }
    }

    patcher(shouldSave);

    /* should open the patched single -> we need the queue. This was the original save:
      if (shouldSave === true) {
        this.props.patchItem('/persons', '/'+id, patch)
        this.props.fetchMessage('/persons', params);
        this.props.openPerson('/persons', '/'+id);
      } else {
        if (patch.length > 0) {
          if (confirm('A formon el nem mentett változtatások vannak.\nHa a form bezáródik, akkor a változtatások elvesznek.\n\nBezárjuk a form-ot?')) {
            this.props.closePerson()
            this.props.clearNames()
            this.props.fetchMessage('/persons', params);
            this.setState({open: false});
          }
        } else {
          this.props.closePerson()
          this.props.clearNames()
          this.props.fetchMessage('/persons', params);
          this.setState({open: false});
        }
      }
    */
  }

  scrollTo = (element, to, duration) => {
    //t = current time
    //b = start value
    //c = change in value
    //d = duration
    Math.easeInOutQuad = function (t, b, c, d) {
      t /= d/2;
      if (t < 1) return c/2*t*t + b;
      t--;
      return -c/2 * (t*(t-2) - 1) + b;
    };
    var start = element.scrollTop,
      change = to - start,
      currentTime = 0,
      increment = 20;
    var animateScroll = function(){
      currentTime += increment;
      var val = Math.easeInOutQuad(currentTime, start, change, duration);
      element.scrollTop = val;
      if(currentTime < duration) {
        setTimeout(animateScroll, increment);
      }
    };
    animateScroll();
  }

  handleFilter({query, category, diplomas, psychotherapist, newsletter}) {
    params = '?';
    if (typeof query !== 'undefined') {
      params = params + '&q='+query
    }
    if (typeof category !== 'undefined' && category !== '') {
      params = params + '&category='+category
    }
    if (typeof diplomas !== 'undefined') {
      params = params + '&diplomas='+diplomas
    }
    if (typeof psychotherapist !== 'undefined') {
      params = params + '&psychotherapist='+psychotherapist
    }
    if (typeof newsletter !== 'undefined') {
      params = params + '&newsletter='+newsletter
    }
    window.scrollTo(document.body, 0, 1250);
    this.setState({filterparams: params});
    this.setState({advancedfilterparams: "?"});
    this.setState({advancedfilterinuse: false});
    this.props.fetchMessage('/persons', params);
  }

  handleAdvancedFilter({personal, system, psychoterapist, diplomas, membershipType, qualification}) {
    let advancedparams = '?';
    console.log({personal, system, psychoterapist, diplomas, membershipType, qualification})
    if (typeof personal.name !== 'undefined') {
      advancedparams = advancedparams + '&name='+personal.name
    }
    if (typeof personal.birthday !== 'undefined') {
      advancedparams = advancedparams + '&birthday='+personal.birthday
    }
    if (typeof personal.isDead !== 'undefined') {
      if (personal.isDead !== '---') {
        advancedparams = advancedparams + '&isDead='+personal.isDead
      }
    }
    if (typeof personal.address.zip !== 'undefined') {
      advancedparams = advancedparams + '&zip='+personal.address.zip
    }
    if (typeof personal.address.country !== 'undefined') {
      advancedparams = advancedparams + '&country='+personal.address.country
    }
    if (typeof personal.address.city !== 'undefined') {
      advancedparams = advancedparams + '&city='+personal.address.city
    }
    if (typeof personal.address.address !== 'undefined') {
      advancedparams = advancedparams + '&address='+personal.address.address
    }
    if (typeof personal.email !== 'undefined') {
      advancedparams = advancedparams + '&email='+personal.email
    }
    if (typeof personal.phone !== 'undefined') {
      advancedparams = advancedparams + '&phone='+personal.phone
    }
    if (typeof personal.isPublicContact !== 'undefined') {
      if (personal.isPublicContact !== '---') {
        advancedparams = advancedparams + '&isPublicContact='+personal.isPublicContact
      }
    }
    if (typeof system.tbNumber !== 'undefined') {
      advancedparams = advancedparams + '&tbNumber='+system.tbNumber
    }
    if (typeof system.indexNumber !== 'undefined') {
      advancedparams = advancedparams + '&indexNumber='+system.indexNumber
    }
    if (typeof system.isNewsletter !== 'undefined') {
      if (system.isNewsletter !== '---') {
        advancedparams = advancedparams + '&isNewsletter='+system.isNewsletter
      }
    }
    if (typeof psychoterapist.isPsychotherapist !== 'undefined') {
      if (psychoterapist.isPsychotherapist !== '---') {
        advancedparams = advancedparams + '&isPsychotherapist='+psychoterapist.isPsychotherapist
      }
    } else {
      if (typeof psychoterapist.isPatientgroup !== 'undefined') {
        if (psychoterapist.isPatientgroup !== '---') {
          advancedparams = advancedparams + '&isPatientgroup='+psychoterapist.isPatientgroup
        }
      }
      if (typeof psychoterapist.isTheory !== 'undefined') {
        if (psychoterapist.isTheory !== '---') {
          advancedparams = advancedparams + '&isTheory='+psychoterapist.isTheory
        }
      }
      if (typeof psychoterapist.isExam !== 'undefined') {
        if (psychoterapist.isExam !== '---') {
          advancedparams = advancedparams + '&isExam='+psychoterapist.isExam
        }
      }
    }
    if (typeof diplomas !== 'undefined') {
      advancedparams = advancedparams + '&diplomas='+diplomas
    }
    if (typeof membershipType !== 'undefined') {
      if (membershipType !== '---') {
        advancedparams = advancedparams + '&membershipType='+membershipType
      }
    }
    if (typeof qualification !== 'undefined') {
      if (qualification !== '---') {
        let res = qualification.split('-');
         advancedparams = advancedparams + '&qualificationArea='+res[0]+'&qualificationType='+res[1]
      }
    }
    window.scrollTo(document.body, 0, 1250);
    this.setState({filterparams: "?"});
    this.setState({advancedfilterparams: advancedparams});
    this.setState({advancedfilterinuse: true});
    this.props.setFilter({personal, system, psychoterapist, diplomas, membershipType, qualification})
    this.props.fetchMessage('/persons.search', advancedparams);
    this.setState({open: false});
    this.setState({openedfilter: false});
  }

  handleFakeSubmit = (should) => {
    // ugly workaround. Sorry for that :/
    if (should === false) {
      shouldSave = false;
      let classes = document.getElementsByClassName('PersonFormSubmitButton');
      if (typeof classes !== 'undefined' && classes.length > 0) {
        let Rate = classes[0];
        let Btn = Rate.getElementsByTagName('button')[0];
        Btn.click();
      } else {
        this.setState({open: false});
      }
    } else {
      shouldSave = true;
      let classes = document.getElementsByClassName('PersonFormSubmitButton');
      if (typeof classes !== 'undefined' && classes.length > 0) {
        let Rate = classes[0];
        let Btn = Rate.getElementsByTagName('button')[0];
        Btn.click();
      } else {
        this.setState({open: false});
      }
    }
  }

  handleFakeFilter = () => {
    // ugly workaround. Sorry for that :/
      shouldSave = true;
      let classes = document.getElementsByClassName('AdvancedFilterSubmitButton');
      let Rate = classes[0];
      let Btn = Rate.getElementsByTagName('button')[0];
      Btn.click();
  }

  delete (text) {
    return () => {
      this.props.change(text, null)
    }
  }

  csvExport = () => {
    let d = new Date();
    let t = d.getTime();
    let fullparam = '?'
    if (this.state.advancedfilterparams !== 'undefined' && this.state.advancedfilterparams !== "?") {
      if (this.state.advancedfilterparams.indexOf('?') > -1) {
        fullparam = this.state.advancedfilterparams+'&t='+t
      } else {
        fullparam = '?'+this.state.advancedfilterparams+'&t='+t
      }
      var request = new XMLHttpRequest();
      request.open('GET', 'https://admin.magyarpszichodrama.hu/api/v1.0/persons.search.csv'+fullparam);
      request.responseType = 'blob';
      request.setRequestHeader('X-Auth-Token', localStorage.getItem('token'));
      var blob;
      request.onload = function() {
        blob = request.response;
        FileSaver.saveAs(blob, "persons.csv");
      };
      request.send();
    } else {
      if (typeof this.state.filterparams !== 'undefined' && this.state.filterparams !== '') {
        if (this.state.filterparams.indexOf('?') > -1) {
          fullparam = this.state.filterparams+'&t='+t
        } else {
          fullparam = '?'+this.state.filterparams+'&t='+t
        }
      } else {
        fullparam = fullparam+'t='+t
      }
      var request = new XMLHttpRequest();
      request.open('GET', 'https://admin.magyarpszichodrama.hu/api/v1.0/persons.csv'+fullparam);
      request.responseType = 'blob';
      request.setRequestHeader('X-Auth-Token', localStorage.getItem('token'));
      var blob;
      request.onload = function() {
        blob = request.response;
        FileSaver.saveAs(blob, "persons.csv");
      };
      request.send();
    }
  }

  render() {
    if(typeof this.props.message !== 'undefined') {
      let uu = uuidv4();
      return (
        <div style={{paddingBottom: 351}}>
          <AppBar
            title="Személyek"
          />
          <Dialog
            actions={[
              <RaisedButton
                label='Mentés'
                onTouchTap={ this.handleFakeSubmit }
                primary={true}
              />,
              <FlatButton
                label='Bezár'
                onTouchTap={ this.handleClose }
              />
            ]}
            modal={false}
            open={this.state.open}
            onRequestClose={this.handleClose}
            autoScrollBodyContent={true}
            contentStyle={styles.customContentStyle}
          >
            <PersonForm
              handleClose={this.handleClose.bind(this)}  // function
              anonimize={this.props.anonimize}  // function from index -> query - POST
              onSubmit={this.handleSubmit.bind(this)}  // function
              errorMessage={this.props.errorMessage}  // mapStateToProps
              personinfos={this.props.thisperson}  // mapStateToProps
              //editinfos={this.props.editedperson}  // mapStateToProps
              qualification={this.props.qualification}  // mapStateToProps
              qualificationtypes={this.props.qualificationtypes}  // mapStateToProps
              membership={this.props.membership}  // mapStateToProps
              names={this.props.names}  // mapStateToProps
              getEnums={this.props.getEnums}  // function from index -> query - GET
              groups={this.props.groups}  // mapStateToProps
              tracker={this.props.tracker}  // person form values
              track={this.props.track}  // person form values
              fees={this.props.fees}  // mapStateToProps
            />
          </Dialog>
          <PersonListFilter
            personcategories={this.props.personcategories}
            onSubmit={this.handleFilter.bind(this)}
            errorMessage={this.props.errorMessage}
          />
          <RaisedButton
            label={this.state.advancedfilterinuse === true ? 'Részletes keresés (aktív)' : 'Részletes keresés'}
            onTouchTap={ this.handleFilterOpen }
            primary={true}
            className={this.state.advancedfilterinuse === true ? 'red' : 'notred'}
          />
          {this.state.advancedfilterinuse}
          <Dialog
            actions={[
              <RaisedButton
                label='Szűrés'
                onTouchTap={ this.handleFakeFilter }
                primary={true}
              />,
              <FlatButton
                label='Bezár'
                onTouchTap={ this.handleFilterClose }
              />
            ]}
            modal={false}
            open={this.state.openedfilter}
            onRequestClose={this.handleClose}
            autoScrollBodyContent={true}
            contentStyle={styles.customContentStyle}
          >
            <PersonListAdvancedFilter
              personcategories={this.props.personcategories}
              onSubmit={this.handleAdvancedFilter.bind(this)}
              errorMessage={this.props.errorMessage}
              filteroptions={this.props.filteroptions}
              filtertracker={this.props.filtertracker}

              qualification={this.props.qualification}  // mapStateToProps
              qualificationtypes={this.props.qualificationtypes}  // mapStateToProps
              membership={this.props.membership}  // mapStateToProps
              names={this.props.names}  // mapStateToProps
              getEnums={this.props.getEnums}  // function from index -> query - GET
            />
          </Dialog>
          <div>
            <FlatButton label="CSV Export" onClick={this.csvExport.bind(this)} />
          </div>
          <List>
          {
            this.props.message.map((option, index) => {
              let tbnumber;
              if (typeof option.tbNumber !== "undefined") {
                if (option.tbNumber.length > 0) {
                  tbnumber = <span>
                    <span style={{color: darkBlack}}>TB szám:</span>
                    <span> {option.tbNumber} </span>
                  </span>
                }
              }
              let indexnumber;
              if (typeof option.indexNumber !== "undefined") {
                if (option.indexNumber.length > 0) {
                  indexnumber = <span>
                    <span> </span>
                    <span style={{color: darkBlack}}>Index:</span>
                    <span> {option.indexNumber} </span>
                  </span>
                }
              }
              let szuletesnap;
              if (typeof option.birthday !== "undefined") {
                if (option.birthday.length > 0) {
                  szuletesnap = <span>
                    <span> </span>
                    <span style={{color: darkBlack}}>Született:</span>
                    <span> {option.birthday} </span>
                  </span>
                }
              }
              let eMail;
              if (typeof option.email !== "undefined") {
                if (option.email.length > 0) {
                  eMail = <span>
                    <span> </span>
                    <span style={{color: darkBlack}}>Email:</span>
                    <span> {option.email} </span>
                  </span>
                }
              }
              let cim;
              if (typeof option.address !== "undefined") {
                if (option.address.length > 0) {
                  cim = <span>
                    <span> </span>
                    <span style={{color: darkBlack}}>Cím:</span>
                    <span> {option.address} </span>
                  </span>
                }
              }
              return <ListItem
                key={index}
                leftIcon={<ActionFace />}
                primaryText={
                  <span>
                    <small>
                      <Checkbox
                        label="összevonás"
                        className='tobottombar'
                        name={'merge'+index}
                        checked={this.state.checked === option.id ? true : false }
                        onCheck={this.handleMerge.bind(this, option.id)}
                        style={styles.checkbox}/>
                    </small>
                    <span
                      onClick={this.handleOpen.bind(this, option.id)}
                    >
                      <span style={{color: darkBlack}}>{option.name}</span>
                      <small style={{color: lightBlack}}>
                        <span> - </span>
                        {tbnumber}
                        {indexnumber}
                        {szuletesnap}
                        {eMail}
                        {cim}
                      </small>
                    </span>
                  </span>
                }
              />
            })
          }
          </List>
          <Waypoint onEnter={({ previousPosition, currentPosition, event }) => {
              if (this.props.message.length > 49) {
                this.props.fetchMoreMessage('/persons', params+'&offset='+this.props.message.length+'&limit=50');
              }
            }}
          />
          <FloatingActionButton
            className="plusPerson"
            style={styles.plusButton}
            onClick={this.handleNewOpen.bind(this, uu)}
            key={uu} >
            <ContentAdd />
          </FloatingActionButton>
        </div>
      )
    } else {
      return (
        <div>
          <p style={{margin: 16, textAlign: "center"}}><strong>Töltünk...</strong></p>
        </div>
      )
    }
  }
}

function mapStateToProps(state) {
  return {
    message: state.auth.message,
    thisperson: state.person.thisperson,
    qualification: state.person.qualification,
    qualificationtypes: state.person.qualificationtypes,
    membership: state.person.membership,
    personcategories: state.person.personcategories,
    names: state.person.names,
    groups: state.person.groups,
    track: state.person.track,
    tracker: state.form.person,
    filtertracker: state.form.personListAdvancedFilter,
    errorMessage: state.auth.error,
    fees: state.person.fees,
    filterparams: state.person.filteroptions,
  }
}

export default connect(mapStateToProps, actions)(Persons)


// WEBPACK FOOTER //
// ./src/components/persons/persons.js